import { AccessLoggerService, IAccessLoggerService } from "@/framework/logger/accessLog/accessLoggerService";

enum InRoomServiceType {
  Admin = "admin panel",
  Staff = "web staff",
  Guest = "guest",
}

export enum LogCategory {
  // fe-guest
  SubMenu = "sub_menu",
  Facility = "facility",
  Coupon = "coupon",
  Home = "home",
  // fe-pwa: Staff
  PhoneCall = "phone_call",
  Chat = "chat",
}

export enum LogAction {
  // fe-pwa: Staff
  JoinStaffGroup = "join_staff_group",
  LeaveStaffGroup = "leave_staff_group",
  AcceptQuery = "accept_query",
  RejectQuery = "reject_query",
  ForwardQueryGroup = "forward_query_group",
  ForwardQueryIndividual = "forward_query_individual",
  ForwardQueryCancel = "forward_query_cancel",
  ForwardQueryAccept = "forward_query_accept",
  ForwardQueryReceived = "forward_query_received",
  CompleteQuery = "complete_query",
  PostMessage = "post_message",
  StartRing = "start_ringing",
  StopRing = "stop_ringing",
  StaffReceivedCall = "staff_receives",
  StaffAcceptedCall = "staff_accept",
  StaffEndedCall = "staff_end",
  // common
  Login = "login",
  Logout = "logout",
}

class AccessLog {
  private category: any;
  private action: any;
  private data: any;

  constructor(category: any, action: any, data: any) {
    this.category = category;
    this.action = action;
    this.data = data;
  }
}

export class AccessLogRepository {
  private _accessLoggerService: IAccessLoggerService;

  constructor(accessLoggerService: IAccessLoggerService = new AccessLoggerService()) {
    this._accessLoggerService = accessLoggerService;
  }

  async sendFePWAStaffLog(action: string | undefined, data: any = {}, category: string = "") {
    category = `${InRoomServiceType.Staff} ${category ? category : ""}`;
    const log = new AccessLog(category.trim(), action, data);
    await this._accessLoggerService.sendAccessLog(log);
  }

  async sendFePWAAdminLog(action: string | undefined, data: any = {}) {
    const log = new AccessLog(InRoomServiceType.Admin, action, data);
    await this._accessLoggerService.sendAccessLog(log);
  }
}
